var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IVR_ENTITY_I18N_ANNOTATION = "ivr:i18n";
export var IVR_CONFIG_ANNOTATION = "ivr:config";
export var IVR_PROMPTS_ANNOTATION = "ivr:prompts";
export var IVR_PHONE_NUMBER_ANNOTATION = "ivr:phone-number";
export var parseIvrEntityAnnotations = function (annotations) {
    var obj = __assign({}, (annotations !== null && annotations !== void 0 ? annotations : {}));
    var ivrRaw = obj[IVR_ENTITY_I18N_ANNOTATION];
    var parsed = {};
    if (typeof ivrRaw === "string") {
        try {
            parsed = JSON.parse(ivrRaw);
        }
        catch (e) {
            console.error("Failed to parse ivr entity annotations", e);
        }
    }
    else if (ivrRaw) {
        console.error("Unexpected type of ivr entity annotation", typeof ivrRaw, ivrRaw);
    }
    obj[IVR_ENTITY_I18N_ANNOTATION] = parsed;
    return obj;
};
export var serializeIvrEntityAnnotations = function (annotations) {
    var result = __assign({}, (annotations !== null && annotations !== void 0 ? annotations : {}));
    var ivr = result[IVR_ENTITY_I18N_ANNOTATION];
    if (ivr && typeof ivr === "object") {
        result[IVR_ENTITY_I18N_ANNOTATION] = JSON.stringify(ivr);
    }
    // TODO: Api contract requires annotations to be string:string,
    //  but we only update the ivr object here to avoid affecting elsewhere.
    return result;
};
